import type { ReactNode } from "react";

/** 放在表格容器内。标题说明为什么空，正文说明可以做什么。 */
export function EmptyState({ title, children, action }: { title: ReactNode; children?: ReactNode; action?: ReactNode }) {
  return (
    <div className="ax-empty">
      <div className="ax-empty-title">{title}</div>
      {children && <div className="ax-empty-body">{children}</div>}
      {action}
    </div>
  );
}
